
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/idee-verdi",
      function () {
        return require("private-next-pages/idee-verdi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/idee-verdi"])
      });
    }
  